import React, { Component, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import Helmet from 'react-helmet';
import { Container, Card } from 'react-bootstrap';

import { capitalizeFirstLetter } from '../../../../util/text.js';

import { getUserGroup, USER_GROUP_DEFAULT } from '../../../User/UserGroupActions.js';

import Icon from '../../../../components/Content/Icon.js';
import withRouter from '../../../../components/Router/WithRouter.js';
import PageWrapper from '../../../../components/Content/PageWrapper.js';
import PageTitle from '../../../../components/Content/PageTitle.js';
import ContactForm from '../../components/form/ContactForm.js';

function ContactPage({ intl, params, userGroup = null, ...props }) {
	const [mounted, setMounted] = useState(false);
	useEffect(() => {
		setMounted(true);
	}, []);

    const group = (params || {}).group || (userGroup || {}).identifier || '';
    return (
        <div>
            <Helmet
                title={intl.formatMessage({
                    id: group && group !== USER_GROUP_DEFAULT ? `contactPageTitle${capitalizeFirstLetter(group.replace('-', ''))}` : 'contactPageTitle',
                    defaultMessage: 'Contact us - {group}',
                }, { group: capitalizeFirstLetter(group || USER_GROUP_DEFAULT) })}
                meta={[
                    {
                        name: 'description',
                        content: `${group && group !== USER_GROUP_DEFAULT ? `${group} - ` : ''}${intl.formatMessage({
                            id: 'contactPageTitle',
                            defaultMessage: 'Contact us',
                        })}`,
                    },
                ]}
            >
                <body data-header-contrast="false" />
            </Helmet>
			<Container className="page-wrapper bg-company pb-5">
				<PageWrapper>
					<PageTitle>
						<h1><Icon icon="mail" /> <FormattedMessage id="contactPageTitle" defaultMessage="Contact us" />{group && <span> - {group.toUpperCase()}</span>}</h1>
					</PageTitle>
					<Card className="shadow">
						<Card.Body>
							{mounted && <ContactForm group={group} />}
						</Card.Body>
					</Card>
				</PageWrapper>
			</Container>
        </div>
    );
}

function mapStateToProps(store, props) {
    return {
        userGroup: getUserGroup(store),
    };
}

ContactPage.propTypes = {
    params: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    userGroup: PropTypes.object,
};

export default withRouter(connect(mapStateToProps)(injectIntl(ContactPage)));
